import { FaMagnifyingGlass } from 'react-icons/fa6'

import { InvoicesTypes } from '../../api/services/invoice/types.ts'
import { convertToShortDate } from '../formatter.ts'
import { invoicePDF } from './invoicePDF.ts'

type TableColumn = {
  header: string
  accessor: string
  render: (row: InvoicesTypes) => JSX.Element
  className: string
  classNameTd: string
}

export const setInvoicesTableColumns = () => {
  const tableColumns: TableColumn[] = [
    {
      header: 'Numer',
      accessor: 'invoiceNumber',
      className: 'text-center',
      classNameTd: 'text-center',
      render: (row: InvoicesTypes) => <>{row.invoice_number}</>
    },
    {
      header: 'Data wystawienia',
      accessor: 'issueDate',
      className: 'text-center',
      classNameTd: 'text-center',
      render: (row: InvoicesTypes) => <>{convertToShortDate(row.created_at)}</>
    }
  ]

  return tableColumns
}

export const setInvoicesTableActions = () => {
  const tableActions = [
    {
      label: 'PDF',
      icon: <FaMagnifyingGlass className="text-lg" />,
      onClick: async (row: InvoicesTypes) => invoicePDF(row.id),
      className: 'text-blue-500 text-xl'
    }
  ]

  return tableActions
}
